<template>
  <div class="contact-us full-screen">
    <nav class="navbar navbar-ct-default" role="navigation-demo">
      <div class="container">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navigation-example-2">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link :to="{path:'/'}" class="text-danger">Regresar Inicio</router-link>
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="navigation-example-2">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <router-link :to="{path:'/'}">Home</router-link>
            </li>
          </ul>
        </div>
        <!-- /.navbar-collapse -->
      </div>
      <!-- /.container-->
    </nav>
    <div class="wrapper wrapper-full-page section content">
      <div class="">
        <div class="container">
              <h1 class="title text-danger text-center">404 Not Found 😭</h1>
              <h2 class="title text-center">Oops! esta pagina no existe 😢.</h2>
        </div>
      </div>
    </div>
    <footer class="footer-demo">
      <div class="container">
        <div class="copyright pull-right pb-5">FASANI
          <i class="fa fa-heart heart"></i>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>
